export const VALIDATION_MESSAGE_DUPLICATE_USER = "Multiple user with same email cannot exist";
export const VALIDATION_MESSAGE_REQUIRED = "All fields are required";
export const ENTITY_FORM_INITIAL_VALUES = {
    correspondentEntityName: '',
    address: '',
    city: '',
    state: '',
    pinCode: '',
    gstNum: '',
    panNo: '',
    // tanNumber: ''
}
export const USER_FORM_INITIAL_VALUES = {
    firstName: '',
    lastName: '',
    email: '',
    contactNo: ''
}